import { RetentionApi } from './permission-api-client/api/retention-api';
import { initializePermissionApi } from './utils';

// Dedicated API client for Retentions
export const retentionApi = initializePermissionApi(RetentionApi);
